export default "__VITE_ASSET__bff9dbbd__"